import React from 'react';
import Close from 'material-ui/svg-icons/navigation/close';
import Check from 'material-ui/svg-icons/navigation/check';

export default ({ value }) => (
  value ? <><span style={{ fontSize: 0 }}>ANO</span><Check /></> : <><span style={{ fontSize: 0 }}>NE</span><Close /></>
);
